import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PartialSaleListing from '../PartialSaleListing/PartialSaleListing';
import PartialSaleWizard from '../PartialSaleWizard/PartialSaleWizard';

const PartialSaleListings = ({partialSales, user, company, partialSaleQuestions}) => {
  // Check if user owns ANY listings (to determine if we should show the columns at all)
  const hasAnyOwnedListings = partialSales.some(ps => ps.is_owner !== false);
  
  // Separate owned and interested listings
  const ownedListings = partialSales.filter(ps => ps.is_owner !== false);
  const interestedListings = partialSales.filter(ps => ps.is_owner === false);
  
  const renderTable = (listings, showMetrics) => (
    <TableContainer component={Paper} style={{ marginBottom: '2rem' }}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Status</TableCell>
            <TableCell>List Date</TableCell>
            <TableCell>Segment</TableCell>
            {showMetrics && <TableCell align="right">Views</TableCell>}
            {showMetrics && <TableCell align="right">Interests</TableCell>}
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listings.map((partialSale) => (
            <PartialSaleListing 
              key={partialSale.name} 
              partialSale={partialSale} 
              company={company} 
              user={user}
              showMetricsColumns={showMetrics} 
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  
  return (
    <>
      <PartialSaleWizard user={user} company={company} partialSaleQuestions={partialSaleQuestions} />
      
      {/* My Partial Sales Listings Section */}
      {ownedListings.length > 0 && (
        <>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', marginTop: '1rem' }}>
            My Partial Sales Listings
          </h2>
          {renderTable(ownedListings, true)}
        </>
      )}
      
      {/* Listings I'm Interested In Section */}
      {interestedListings.length > 0 && (
        <>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', marginTop: '1rem' }}>
            Listings I'm Interested In
          </h2>
          {renderTable(interestedListings, false)}
        </>
      )}
    </>
  );
}

export default PartialSaleListings;